function TeacherStat({ label }) {
  const icons = {
    degree: (
      <svg className="h-5 w-5 text-[#1A87CC]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" d="M12 14l9-5-9-5-9 5 9 5z" />
        <path strokeLinecap="round" d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
      </svg>
    ),
    experience: (
      <svg className="h-5 w-5 text-[#1A87CC]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    videos: (
      <svg className="h-5 w-5 text-[#9369CC]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
      </svg>
    ),
  };

  const iconKey = label.toLowerCase().includes('video')
    ? 'videos'
    : label.toLowerCase().includes('experience')
      ? 'experience'
      : 'degree';

  return (
    <div className="flex items-center gap-2 text-sm font-medium text-[#666666]">
      {icons[iconKey]}
      {label}
    </div>
  );
}

export default function TeacherHeroSection({ teacher }) {
  return (
    <section className="bg-gradient-to-r from-[#53BD0C] to-[#69991D] px-4 py-10 sm:px-6 lg:px-8 lg:py-14">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 items-center gap-8 rounded-3xl bg-white p-6 shadow-[0_8px_40px_rgba(0,0,0,0.08)] sm:p-8 lg:grid-cols-[1fr_280px] lg:gap-10 lg:p-10">
          <div>
            <h1 className="text-3xl font-bold text-[#1B1B1B] sm:text-[40px]">{teacher.name}</h1>
            <p className="mt-2 text-lg font-semibold text-[#9369CC]">{teacher.title}</p>
            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-[#666666] sm:text-base">
              {teacher.bio}
            </p>
            <div className="mt-6 flex flex-wrap gap-x-8 gap-y-3">
              {teacher.stats.map((stat) => (
                <TeacherStat key={stat.id} label={stat.label} />
              ))}
            </div>
          </div>

          <div className="mx-auto w-full max-w-[280px] overflow-hidden rounded-2xl lg:mx-0">
            <img
              src={teacher.profileImage}
              alt={teacher.name}
              className="h-[320px] w-full object-cover object-top lg:h-[340px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
